<template>
  <div class="packages-overview-results">

    <ResultsNavigation v-model:activeFilters="activeFiltersHandler"
                       :filters="filters"
                       v-model:sortOrder="sortOrderHandler"
                       @openFilters="$emit('openFilters')"
                       />

    <ResultsList :activeFilters="activeFilters"
                 :amountPerPage="amountPerPage"
                 :filtersLoaded="filtersLoaded"
                 v-model:loading="loadingHandler"
                 v-model:page="pageHandler"
                 :pageLoaded="pageLoaded"
                 :siteId="siteId"
                 :sortOrder="sortOrder"
                 @resetFilters="$emit('resetFilters')"
                 @setAmount="setAmount"
                 />

    <ResultsPagination :amount="amount"
                       :amountPerPage="amountPerPage"
                       v-model:page="pageHandler"
                       @setPageLoaded="setPageLoaded"
                       />

  </div>
</template>

<script>
import ResultsList from '@/components/Results/List.vue';
import ResultsNavigation from '@/components/Results/Navigation.vue';
import ResultsPagination from '@/components/Results/Pagination.vue';

export default {
  name: 'Results',

  components: {
    ResultsList,
    ResultsNavigation,
    ResultsPagination,
  },

  props: {
    activeFilters: {
      type: Object,
      required: true,
    },
    amount: {
      type: Number,
    },
    amountPerPage: {
      type: Number,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
    filtersLoaded: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    page: {
      type: Number,
    },
    pageLoaded: {
      type: Boolean,
      required: true,
    },
    siteId: {
      type: Number,
      required: true,
    },
    sortOrder: {
      type: String,
      required: true,
    },
  },

  computed: {
    activeFiltersHandler: {
      get() {
        return this.activeFilters;
      },
      set(activeFilters) {
        this.$emit('update:activeFilters', activeFilters);
      },
    },

    loadingHandler: {
      get() {
        return this.loading;
      },
      set(loading) {
        this.$emit('update:loading', loading);
      },
    },

    pageHandler: {
      get() {
        return this.page;
      },
      set(page) {
        this.$emit('update:page', page);
      },
    },

    sortOrderHandler: {
      get() {
        return this.sortOrder;
      },
      set(sortOrder) {
        this.$emit('update:sortOrder', sortOrder);
      },
    },
  },

  methods: {
    setPageLoaded(pageLoaded) {
      this.$emit('update:pageLoaded', pageLoaded);
    },

    setAmount(amount) {
      this.$emit('update:amount', amount);
    },
  },
};
</script>

<style lang="scss" scoped>
  .packages-overview-results {
    flex-grow: 1;
  }
</style>
